type CustomerPortalApiErrorParams = {
  status: number;
  statusText: string;
  url: string | URL;
  method?: string;
  responseBody?: string;
  callerName?: string;
};

/**
 * A non-ok HTTP response from the customer portal API: the API answered and
 * the status carries what it said. Network failures, aborts, token rejections
 * and parse errors are not this type, so react-query error generics stay
 * Error and callers narrow with instanceof before reading status.
 */
export class CustomerPortalApiError extends Error {
  status: number;
  context: CustomerPortalApiErrorParams;

  constructor(params: CustomerPortalApiErrorParams) {
    const messageParts = [`${params.status} ${params.statusText}`];

    if (params.callerName) messageParts.push(params.callerName);
    super(messageParts.join(' - '));
    this.name = 'CustomerPortalApiError';
    this.status = params.status;
    this.context = params;
  }
}
